import './index.less';
export default {
  props: {
    data: { type: Array, default: () => ([]) },
    className: { type: String, default: () => 'antd_menu_whole' },
    defaultOpeneds: { type: Array, default: () => [] },
    uniqueOpened: { type: Boolean, default: false },
    submit: { type: Function, default: () => null }, // 子菜单点击事件
  },
  data() {
    return {
      rootSubmenuKeys: [],
      openeds: [],
    }
  },
  watch: {
    data: function () {
      this.setRootSubmenuKeys();
    }
  },
  created() {
    this.initOpeneds();
  },
  methods: {
    // 初始化展开的submenu
    initOpeneds() {
      this.openeds = this.defaultOpeneds;
    },
    // 设置一级菜单数据
    setRootSubmenuKeys() {
      this.uniqueOpened && (this.rootSubmenuKeys = this.data.map(item => item.id));
    },
    // 处理冒泡
    subMenuClick(e, data) {
      if (e.stopPropagation) {
        e.stopPropagation();
        this.$listeners.subMenuClick(data);
      }
    },
    // 一级菜单发生改变时
    openChange(openeds = []) {
      // 将该事件重新传递给父组件
      let { subMenuChange = () => null } = this.$listeners;
      subMenuChange(openeds);

      // 开启父级菜单收起与展开
      const latestOpenKey = openeds.find(key => this.openeds.indexOf(key) === -1);
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openeds = openeds;
      } else {
        this.openeds = latestOpenKey ? [latestOpenKey] : [];
      };
    },
    formater(arr = []) {
      let { formater } = this;
      // 前面解构出来的为不需要的属性
      return arr.map(({ mode, ...item }) => {
        if (item.children) {
          return <a-sub-menu on={this.$listeners} class={`antd_sub_menu_default ${item.hightLight && 'hight_light'}`} props={item} key={item.key || item.id}>
            <span id={item.id} slot="title" class="submenu-title-wrapper">{item.icon && <a-icon type={item.icon || 'windows'} />}{item.label || item.name || item.content}</span>
            {formater(item.children)}
          </a-sub-menu>
        } else {
          return <a-menu-item class={`antd_menu_item_default ${item.hightLight && 'hight_light'}`} onClick={e => this.submit({ mode, ...item }, e)} props={item} key={item.key || item.id}><span id={item.id}>{item.icon && <a-icon type={item.icon || 'windows'} />}{item.label || item.name || item.content}</span></a-menu-item>
        }
      })
    }
  },
  render() {
    let { $attrs, data, className, openeds } = this;
    let { $listeners, formater, openChange } = this;
    return (
      <div class={`antd_menu_index ${className}`}>
        <a-menu props={$attrs} on={$listeners} onOpenChange={openChange} openKeys={openeds} >{formater(data)}</a-menu>
      </div>
    )
  }
}